import React from 'react';
import logo from '../images/logo.png';



function Footer() {
  return (
    <div>
        <div className="mt-8">
            <div className="bg-white mx-3 mt-3 p-8 md:px-16 md:grid md:grid-cols-3 md:gap-12 rounded-lg shadow">
                <div>
                    <div className="flex items-center justify-start">
                        <a href="/">
                            <img className="h-40 p-3 " src={logo} alt="TractorSingh"/>
                        </a>
                    </div>
                    <div className="mt-3 py-1  text-sm">
                        <p className="font-bold text-gray-600">Address: </p> 
                        <span className="font-light">601, P3 Pentagon, Magarpatta, Hadapsar, Pune, Maharashtra 411028</span>
                    </div>
                    <div className="py-1  text-sm">
                        <p className="font-bold text-gray-600">Phone: </p> 
                        <span className="font-light">+91 99999 00000</span>
                    </div>
                    <div className="py-1  text-sm">
                        <p className="font-bold text-gray-600">Email: </p> 
                        <span className="font-light">contact@tractorsingh.com</span>
                    </div>
                </div>

                <div className="p-2 md:px-4">
                    <div>
                        <h3 className="text-2xl font-bold my-4 tracking-wide text-gray-600">Quick Links</h3>
                    </div>
                    <ul className="md:ml-2">
                        <li className="list-disc m-3"><a>Upcoming Tractors</a></li>
                        <li className="list-disc m-3"><a>Latest Tractors</a></li>
                        <li className="list-disc m-3"><a>Popular Tractors</a></li>
                        <li className="list-disc m-3"><a>Search By Brand</a></li>
                        <li className="list-disc m-3"><a>Implements</a></li>
                        <li className="list-disc m-3"><a>Compare</a></li>
                        <li className="list-disc m-3">
                            <a>
                                Mini Tractors
                                <span className="bg-purple-700 text-white text-xs rounded-full border border-white px-2 py-1 ml-2 hover:bg-white hover:text-purple-700  hover:border-purple-700">exclusive</span>
                            </a>
                        </li>
                        <li className="list-disc m-3">
                            <a>
                                Electric Tractors
                                <span className="bg-purple-700 text-white text-xs rounded-full border border-white px-2 py-1 ml-2 hover:bg-white hover:text-purple-700  hover:border-purple-700">exclusive</span>
                            </a>
                        </li>
                    </ul>
                </div>

                <div className="p-2 md:px-4">
                    <div>
                        <h3 className="text-2xl font-bold my-4 tracking-wide text-gray-600">Important Links</h3>
                    </div>
                    <ul className="md:ml-2">
                        <li className="list-disc m-3"><a>News</a></li>
                        <li className="list-disc m-3"><a>Insurance</a></li>
                        <li className="list-disc m-3"><a>Finance</a></li>
                        <li className="list-disc m-3"><a>About Us</a></li>
                        <li className="list-disc m-3"><a>Terms and Conditions</a></li>
                        <li className="list-disc m-3"><a>Our Policy</a></li>
                        <li className="list-disc m-3"><a>Contact Us</a></li>
                        <li className="list-disc m-3">
                            <a>
                                Advertise With Us
                                <span className="bg-purple-700 text-white text-xs rounded-full border border-white px-2 py-1 ml-2 hover:bg-white hover:text-purple-700  hover:border-purple-700">new</span>
                            </a>
                        </li>
                    </ul>

                </div>
            </div>

            <div className="p-3 mx-3 font-semibold text-sm">
                <p>Tractor Singh Copyright © {new Date().getFullYear()}. All Right Reserved.
                </p>
            </div>
        </div>
    </div>
  );
}

export default Footer;
